import bTable from './table.vue';

export default bTable;


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/table/table.js
// module id = 534
// module chunks = 0